webpackJsonp([112904724367323],{

/***/ 189:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	exports.default = Template;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Template(_ref) {
	  var data = _ref.data;
	  var post = data.markdownRemark;
	
	  return _react2.default.createElement(
	    "div",
	    { className: "node-type-historical-content" },
	    _react2.default.createElement(
	      "div",
	      { className: "node" },
	      _react2.default.createElement(
	        "h2",
	        null,
	        _react2.default.createElement(
	          "a",
	          { href: post.frontmatter.path },
	          post.frontmatter.title
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "content" },
	        _react2.default.createElement(
	          "div",
	          { className: "field-name-field-timeframe" },
	          post.frontmatter.year
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "field-name-body" },
	          _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: post.html } }),
	          post.frontmatter.image && _react2.default.createElement(
	            "span",
	            null,
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("img", {
	              src: post.frontmatter.image.childImageSharp.resize.src,
	              title: post.frontmatter.imagetitle
	            })
	          )
	        ),
	        post.frontmatter.author && _react2.default.createElement(
	          "div",
	          { className: "field-name-field-user-name" },
	          post.frontmatter.author
	        ),
	        post.frontmatter.publication && _react2.default.createElement(
	          "div",
	          { className: "field-name-field-publication-name" },
	          post.frontmatter.publication
	        )
	      )
	    )
	  );
	}
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-template-js-42d2dbf412933e3e9c25.js